import { render, staticRenderFns } from "./abc.vue?vue&type=template&id=b1a9b876&scoped=true"
import script from "./abc.vue?vue&type=script&lang=js"
export * from "./abc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a9b876",
  null
  
)

export default component.exports